function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import styled, { ThemeContext, css } from 'styled-components';
import { EnumProductStates } from "../types";
import Button from "../../Button";
import QuantityControls from "../../QuantityControls";
import Cart from "../../Icon/Cart";
import Plus from "../../Icon/Plus";
import { hideAfterSm, hideBeforeSm } from "../../../theme/helpers/media";
import Flex from "../../Grid/Flex";
import { PRODUCT_ADD_BUTTON_TEST_ID, PRODUCT_BACK_IN_CART_BUTTON_TEST_ID, PRODUCT_NOT_AVALIBLE_BUTTON_TEST_ID } from "../constants";
import colors from "../../../colors/index";
var Container = styled.div.withConfig({
  displayName: "Controls__Container",
  componentId: "sc-14knu8j-0"
})(["flex-grow:1;"]);
export var ButtonStyled = styled(Button).withConfig({
  displayName: "Controls__ButtonStyled",
  componentId: "sc-14knu8j-1"
})(["flex-shrink:0;span{width:max-content;}", ";"], function (_ref) {
  var isKomus = _ref.isKomus;

  if (isKomus) {
    return css(["caret-color:", " !important;background-color:", " !important;border-color:", " !important;color:", " !important;font-size:16px !important;line-height:24px !important;font-weight:500 !important;"], colors.primaryMain, colors.light200, colors.light200, colors.dark300);
  }
});
export var DesktopButtonsWrapper = styled.div.withConfig({
  displayName: "Controls__DesktopButtonsWrapper",
  componentId: "sc-14knu8j-2"
})(["", ";& ", " + ", "{margin-top:8px;}"], hideBeforeSm, ButtonStyled, ButtonStyled);
var MobileButtonsWrapper = styled(Flex).attrs({
  end: true
}).withConfig({
  displayName: "Controls__MobileButtonsWrapper",
  componentId: "sc-14knu8j-3"
})(["", ";"], hideAfterSm);
var StyledCart = styled(Cart).withConfig({
  displayName: "Controls__StyledCart",
  componentId: "sc-14knu8j-4"
})(["", ";"], function (_ref2) {
  var isKomus = _ref2.isKomus;

  if (isKomus) {
    return css(["color:", " !important;"], colors.primaryMain);
  }
});
var StyledPlus = styled(Plus).withConfig({
  displayName: "Controls__StyledPlus",
  componentId: "sc-14knu8j-5"
})(["", ";"], function (_ref3) {
  var isKomus = _ref3.isKomus;

  if (isKomus) {
    return css(["color:", " !important;"], colors.primaryMain);
  }
});

var Controls = function Controls(_ref4) {
  var _EnumProductStates$to;

  var quantity = _ref4.quantity,
      weight = _ref4.weight,
      state = _ref4.state,
      canAddToOrder = _ref4.canAddToOrder,
      onAddToCart = _ref4.onAddToCart,
      onAddToOrder = _ref4.onAddToOrder,
      onQuantityChange = _ref4.onQuantityChange,
      onReturn = _ref4.onReturn,
      showWeight = _ref4.showWeight,
      className = _ref4.className,
      isKomus = _ref4.isKomus;

  var _useContext = useContext(ThemeContext),
      addToBasketText = _useContext.addToBasketText;

  return React.createElement(Container, {
    className: className
  }, (_EnumProductStates$to = {}, _defineProperty(_EnumProductStates$to, EnumProductStates.toBasket, React.createElement(React.Fragment, null, React.createElement(DesktopButtonsWrapper, null, canAddToOrder && onAddToOrder && React.createElement(ButtonStyled, {
    size: "small",
    before: React.createElement(StyledPlus, {
      width: "18",
      height: "18",
      color: "currentcolor"
    }),
    fluid: true,
    onClick: onAddToOrder,
    isKomus: isKomus
  }, "\u0412 \u0437\u0430\u043A\u0430\u0437"), onAddToCart && React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_ADD_BUTTON_TEST_ID,
    size: "small",
    before: React.createElement(StyledCart, {
      color: "currentcolor"
    }),
    fluid: true,
    onClick: onAddToCart,
    isKomus: isKomus
  }, addToBasketText)), React.createElement(MobileButtonsWrapper, null, React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_ADD_BUTTON_TEST_ID,
    size: "small",
    icon: true,
    onClick: onAddToCart,
    isKomus: isKomus
  }, React.createElement(Plus, {
    width: "18",
    height: "18",
    color: "currentcolor"
  }))))), _defineProperty(_EnumProductStates$to, EnumProductStates.inBasket, onQuantityChange && React.createElement(QuantityControls, {
    weight: weight,
    quantity: quantity,
    onChange: onQuantityChange,
    showWeight: showWeight,
    isKomus: isKomus
  })), _defineProperty(_EnumProductStates$to, EnumProductStates.revert, React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_BACK_IN_CART_BUTTON_TEST_ID,
    size: "small",
    fluid: true,
    onClick: onReturn,
    isKomus: isKomus
  }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C")), _defineProperty(_EnumProductStates$to, EnumProductStates.notAvailable, React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_NOT_AVALIBLE_BUTTON_TEST_ID,
    size: "small",
    fluid: true,
    disabled: true,
    isKomus: isKomus
  }, "\u043D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438")), _EnumProductStates$to)[state]);
};

export default styled(Controls).withConfig({
  displayName: "Controls",
  componentId: "sc-14knu8j-6"
})([""]);